import { faCalendarAlt, faFlag, faTag } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { dateToDisplayDateOrEmpty } from 'utils/helpers'

interface ChallengeSpaceSubmissionInfoProps {
	challengeSpace: any
	subject: any
}

const ChallengeSpaceSubmissionInfo = ({
	challengeSpace,
	subject,
}: ChallengeSpaceSubmissionInfoProps) => {
	return (
		<div className="flex flex-wrap items-start justify-between bg-white border-b px-8 py-6">
			<div className="w-full">
				<h3 className="text-xl font-semibold mb-1 mt-0 text-gray-900">
					{challengeSpace.attributes.title}
				</h3>
			</div>
			{!challengeSpace?.attributes?.isOpenChallengeSpace && (
				<>
					<div className="flex flex-row items-center py-2">
						<FontAwesomeIcon
							icon={faCalendarAlt}
							className="text-xl mr-3 text-purple-900"
						/>
						<span className="text whitespace-nowrap text-gray-700 uppercase">
							{dateToDisplayDateOrEmpty(
								challengeSpace.attributes.challengeStartDate
							)}{' '}
							-{' '}
							{dateToDisplayDateOrEmpty(
								challengeSpace.attributes.challengeEndDate
							)}
						</span>
					</div>
					<div className="flex flex-row items-center py-2">
						<FontAwesomeIcon
							icon={faTag}
							className="text-xl mr-3 text-purple-900"
						/>
						<span className="text whitespace-nowrap text-gray-700">
							{subject?.attributes?.title}
						</span>
					</div>
					{challengeSpace.attributes.challengeSubmitDeadline && (
						<div className="flex flex-row items-center py-2">
							<FontAwesomeIcon
								icon={faFlag}
								className="text-xl mr-3 text-purple-900"
							/>
							<span className="text whitespace-nowrap text-gray-700">
								Submit before{' '}
								<strong>
									{dateToDisplayDateOrEmpty(
										challengeSpace.attributes.challengeSubmitDeadline
									)}
								</strong>
							</span>
						</div>
					)}
				</>
			)}
		</div>
	)
}

export default ChallengeSpaceSubmissionInfo
